/**
 * API configuration settings and URL utilities
 */

/** Base URL for all API requests */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Constructs a full API URL from a path
 * @param path - The API endpoint path
 * @returns The complete API URL
 */
export const getApiUrl = (path: string): string => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${API_BASE_URL}/${cleanPath}`;
};
